import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const QuizDataSlice = createSlice({
    name: "Quiz",
    initialState,
    reducers: {
        getQuizRequest(state) {
            state.loading = true;
        },
        getQuizRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getQuizRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getQuizRequest,
    getQuizRequestSuccess,
    getQuizRequestError,
} = QuizDataSlice.actions;

export default QuizDataSlice.reducer;
